enum routesEnum {
	HOME = '/',
	SUBSCRIPTION = '/assinatura',
	PAYMENT_PIX = '/payment/pix',
	PAYMENT_CREDIT = '/payment/credit',
	PAYMENT_STATUS = '/payment/status'
}

export default routesEnum
